function envList() {
    return  [
        { id: '0', name: 'P1' },
        { id: '1', name: 'P2' },
        { id: '2', name: 'P3' },
        { id: '3', name: 'P4' }
    ]
}

export default {
    envList
}
